import { useContext, useState, useEffect } from "react";
import { Box, Collapse, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import NavButton from "./NavButton";
import { GlobalContext } from "../Context";
import { PREMIUM_PAGES, NAVBAR_OPTIONS } from "../../../constants";
import { useTranslation } from "react-i18next";
import PlayerCard from "./PlayerCard";
import { background } from "../../../theme/colours";
import { NAVBAR_TOGGLE } from "../../../constants/ids";

const Navbar = () => {
  const { t } = useTranslation("Navigation");
  const { userState, optionState, setOptionState } = useContext(GlobalContext);

  const [isOpen, setIsOpen] = useState(false);
  const [hoverStop, setHoverStop] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const containerStyleWrapper = {
    display: "flex",
    flexDirection: "row",
    position: "fixed",
    height: "calc(100% - 4.5rem)",
    top: "4.5rem",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "bold",
    boxShadow: "rgb(191 188 195) 0px 1px 8px",
    zIndex: 1200,
  };
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: background.primary,
    transitionDuration: "250ms",
    zIndex: 6,
    py: 2,
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  };
  const iconButtonStyle = {
    height: "100px",
    position: "absolute",
    top: "40%",
    right: "-38px",
    backgroundColor: background.primary,
    borderRadius: "0 10px 10px 0",
    boxShadow: "0px 1px 4px 1px #bfbcc3",
    zIndex: 5,
    "&: hover": {
      backgroundColor: background.primary,
    },
    transition: "left 250ms",
    "& svg": {
      opacity: 0.5,
    },
  };

  const handleClick = () => {
    if (isOpen) {
      setIsOpen(false);
      setHoverStop(false);
    }
    if (!isOpen) {
      setIsOpen(true);
      setHoverStop(true);
      setIsHovering(true);
    }
  };

  const handleNavClick = (type) => {
    setOptionState({ nav: type, page: "main" });
  };
  const handleMouseEnter = () => {
    !hoverStop && setIsOpen(true);
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    !hoverStop && setIsOpen(false);
    setIsHovering(false);
  };

  useEffect(() => {
    const html = document.querySelector("html");
    html && (html.style.overflowY = isHovering ? "hidden" : "auto");
    return () => {
      const html = document.querySelector("html");
      html && (html.style.overflowY = "auto");
    };
  }, [isHovering]);

  const renderNavButton = (option) => {
    const freeUser =
      !userState.isAdmin && !userState.isPremium && !userState.isMedidas;

    const text =
      option.name === "campaign"
        ? userState.isAdmin
          ? t("campaigns")
          : t("challenges")
        : option.name === "competitionInfo"
        ? t("challenges")
        : t(option.name);

    if (freeUser && PREMIUM_PAGES.find((page) => page === option.name)) {
      return null;
    }

    return (
      <NavButton
        key={`NavBar-${option.name}`}
        name={option.name}
        text={text}
        activeButton={optionState.nav}
        handleClick={handleNavClick}
        icon={option.icon}
      />
    );
  };

  return (
    <Box sx={containerStyleWrapper}>
      <IconButton sx={iconButtonStyle} onClick={handleClick} id={NAVBAR_TOGGLE}>
        {isOpen ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
      <Box
        sx={containerStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <Collapse
          in={isOpen}
          collapsedSize={84}
          orientation="horizontal"
          timeout={250}>
          <PlayerCard isOpen={isOpen} />
          {NAVBAR_OPTIONS.map(renderNavButton)}
        </Collapse>
      </Box>
    </Box>
  );
};

export default Navbar;
